import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

/** Used only by IntegrationsDashboardComponent. */
@Pipe({
  name: 'zbpIsoDate',
  standalone: false
})
export class IsoDatePipe implements PipeTransform {

  /**
   * Transforms ISO date string provided by the API.
   *
   * @example
   * // Use the default format.
   * <time [attr.datetime]="value">{{ value | zbpIsoDate }}</time>
   * @example
   * // Use a different format.
   * <time [attr.datetime]="value">{{ value | zbpIsoDate:'YYYY.M.D'}}</time>
   */
  transform(value: string, format: string = 'M/D/YYYY @ h:mma'): unknown {
    if (value) {
      // @todo swap out moment for whatever when moment is ready to be removed.
      return moment(value).format(format);
    }
    return 'N/A';
  }

}
